/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';

function MoonIcon(props, svgRef) {
  return React.createElement("svg", Object.assign({
    "data-sanity-icon": "moon",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), React.createElement("path", {
    d: "M19.6065 16.1775L20.1392 16.4537L20.8043 15.1709L19.4262 15.6052L19.6065 16.1775ZM12.6004 4.50062L13.0204 4.92911L14.0515 3.91842L12.6078 3.90066L12.6004 4.50062ZM19.4262 15.6052C18.819 15.7966 18.1722 15.9 17.5 15.9V17.1C18.2959 17.1 19.0644 16.9774 19.7869 16.7497L19.4262 15.6052ZM17.5 15.9C13.9654 15.9 11.1 13.0346 11.1 9.5H9.9C9.9 13.6974 13.3026 17.1 17.5 17.1V15.9ZM11.1 9.5C11.1 7.70936 11.8346 6.09138 13.0204 4.92911L12.1804 4.07212C10.7738 5.4508 9.9 7.37389 9.9 9.5H11.1ZM12.5 5.1C12.5311 5.1 12.5621 5.10019 12.593 5.10057L12.6078 3.90066C12.5719 3.90022 12.536 3.9 12.5 3.9V5.1ZM5.1 12.5C5.1 8.41309 8.41309 5.1 12.5 5.1V3.9C7.75035 3.9 3.9 7.75035 3.9 12.5H5.1ZM12.5 19.9C8.41309 19.9 5.1 16.5869 5.1 12.5H3.9C3.9 17.2496 7.75035 21.1 12.5 21.1V19.9ZM19.0739 15.9013C17.8414 18.2781 15.3596 19.9 12.5 19.9V21.1C15.8252 21.1 18.7085 19.2127 20.1392 16.4537L19.0739 15.9013Z",
    fill: "currentColor"
  }));
}

var ForwardRef = React.forwardRef(MoonIcon);
export default ForwardRef;